module.exports = __webpack_public_path__ + "static/media/arrow-left-green.d569a030.svg";